<template>
    <div>
      <SearchForm
        :categoryConf="categoryConf"
        :configs="topicConfig.searchFormConfigs"
        @formDataChange="onFormDataChange"
      />
      <div class="before-slot" v-html="categoryConf.beforeSlot"></div>
      <div class="msg-box">
        <!-- List View -->
        <component
          v-if="topicConfig.showStyle === 'list'"
          :is="topicConfig.isScroll ? ElScrollbar : 'div'"
          :style="{
            height:
              typeof topicConfig.arcHeight === 'number'
                ? topicConfig.arcHeight + 'px'
                : 'auto',
          }"
        >
          <div
            v-for="(item, i) in articleList"
            :key="i"
            class="new-box-item"
          >
            <el-image
              class="new-box-img-item"
              :style="{
                height:
                  typeof topicConfig.imageHeight === 'number'
                    ? topicConfig.imageHeight + 'px'
                    : '92px',
                width:
                  typeof topicConfig.imageWidth === 'number'
                    ? topicConfig.imageWidth + 'px'
                    : '55px',
              }"
                       referrerpolicy="no-referrer"
              :src="item.coverPic ? item.coverPic : ''"
            />
            <div class="new-box-cont">
              <h6 class="new-box-cont-title">
                <NuxtLink :to="`/detail${isPc ? '/pc' : ''}?detailId=${item.id}`">
                  {{ item.title }}
                </NuxtLink>
              </h6>
              <p class="new-box-cont-time">
                {{ item.createTime && item.createTime.split(' ')[0] }}
              </p>
            </div>
          </div>
        </component>
  
        <!-- Image List View -->
        <component
          v-if="topicConfig.showStyle === 'imageList'"
          :is="topicConfig.isScroll ? ElScrollbar : 'div'"
          :style="{
            height:
              typeof topicConfig.arcHeight === 'number'
                ? topicConfig.arcHeight + 'px'
                : 'auto',
          }"
        >
          <div class="new-image-wrap">
            <div
              v-for="(item, i) in articleList"
              :key="i"
              class="new-image-item"
            >
              <el-image
                class="new-image-pic"
                :title="item.title"
                :previewSrcList="[item.coverPic ? item.coverPic : '']"
                :style="{
                  height:
                    typeof topicConfig.imageHeight === 'number'
                      ? topicConfig.imageHeight + 'px'
                      : '92px',
                  width:
                    typeof topicConfig.imageWidth === 'number'
                      ? topicConfig.imageWidth + 'px'
                      : '55px',
                }"
                         referrerpolicy="no-referrer"
                :src="item.coverPic ? item.coverPic : ''"
              />
            </div>
          </div>
        </component>
  
        <!-- Content List View -->
        <component
          v-if="topicConfig.showStyle === 'contentList'"
          :is="topicConfig.isScroll ? ElScrollbar : 'div'"
          :style="{
            height:
              typeof topicConfig.arcHeight === 'number'
                ? topicConfig.arcHeight + 'px'
                : 'auto',
          }"
        >
          <div
            v-for="(item, i) in articleList"
            :key="i"
            class="new-detail-item"
          >
            <NuxtLink
              v-if="!topicConfig.hiddenTitle"
              class="new-detail-item-title-link"
              :to="`/detail${isPc ? '/pc' : ''}?detailId=${item.id}`"
            >
              <h6 class="new-detail-item-title">
                {{ item.title }}
              </h6>
            </NuxtLink>
            <div class="new-detail-item-cont" v-html="item.content"></div>
          </div>
        </component>
  
        <!-- Pagination -->
        <el-pagination
          v-if="topicConfig.isShowPagination"
          :currentPage="pageNo + 1"
          :page-size="topicConfig.isShowArticleLength"
          layout="prev, next, jumper"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
      <div class="after-slot" v-html="categoryConf.afterSlot"></div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { getActiveListFormPlatform } from '@/api';
  import SearchForm from '../common/SearchForm.vue';
  import useLocate from "../uses/useLocate.js";
  import { ElScrollbar } from "element-plus";
let { langJson, nowLocale, getLocaleText } = useLocate();
  
  // 接收props
  const props = defineProps({
    allArcListMap: {
      type: Object,
      default: () => ({}),
    },
    currentElementIndex: {
      type: Array,
      default: () => [],
    },
    idx: {
      type: Number,
      default: -1,
    },
    parentKeys: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    topicConfig: {
      type: Object,
    },
    categoryConf: {
      type: Object,
    },
  });
  
  // 响应式数据
  const pageNo = ref(0);
  const total = ref(0);
  const list = ref([]);
  const searchData = ref({});
  const isPc = computed(() => {
    return !['v/m', 'siteweb', 'web'].some(path => useRoute().path.includes(path));
  });
  
  // 计算属性：处理文章列表
  const articleList = computed(() => {
    return list.value.map(item => {
      if (item.type === 1 && item.content) {
        item.content = item.content.replace("video", "video autoplay ");
      }
      return { ...item };
    });
  });
  
  // 获取文章列表数据
  const fetchFunc = async (fetchData = {}) => {
    try {
      const responseData = await getActiveListFormPlatform({
        categoryId: props.categoryConf.id,
        topicId: props.topicConfig.themeId,
        pageNo: pageNo.value,
        pageSize: props.topicConfig.isShowArticleLength,
        ...fetchData,
      });
  
      list.value = responseData.data.dataList.map(o => ({ ...o }));
      total.value = responseData.data.totalRecord || 0;
    } catch (e) {
      console.log(e);
    }
  };
  
  // 分页变化
  const handleCurrentChange = (data) => {
    pageNo.value = data - 1;
    fetchFunc();
  };
  
  // 搜索表单数据变化
  const onFormDataChange = (v) => {
    searchData.value = v;
    fetchFunc(v);
  };
  
  // 组件挂载时获取数据
  onMounted(() => {
    fetchFunc();
  });
  </script>
  

  <style scoped>
  .msg-box-item {
    overflow: hidden;
    margin-bottom: 15px;
  }
  .msg-box-time-item {
    width: 56px;
    height: 56px;
    background: #f1f5f2;
    display: inline-block;
    text-align: center;
    margin: 0px 10px 0 0;
    vertical-align: middle;
  }
  .msg-box-time-item-top {
    font-size: 22px;
    font-family: DINAlternate-Bold, DINAlternate;
    color: #5b675c;
    line-height: 24px;
    margin-top: 7px;
    margin-bottom: 2px;
  }
  .msg-box-time-item-bottom {
    height: 14px;
    font-size: 12px;
    font-family: DINAlternate-Bold, DINAlternate;
    color: #5b675c;
    line-height: 14px;
  }
  .msg-box-cont {
    width: 159px;
    max-height: 60px;
    overflow: hidden;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 21px;
    display: inline-block;
    vertical-align: middle;
  }
  .msg-box-cont-link {
    color: #666666;
    text-decoration: none;
  }
  .msg-box-cont-link:hover {
    color: #2a672d;
  }
  .msg-box :deep(.el-scrollbar__wrap ){
    overflow-x: hidden;
  }
  .new-box-item {
    overflow: hidden;
    margin-bottom: 12px;
    display: flex;
  }
  .new-box-item.active .new-box-img-item {
    border: 2px solid #2a672d;
  }
  .new-box-item.active .new-box-cont-title :deep(a) {
    color: #2a672d;
  }
  .new-box-item.active .new-box-cont-time {
    color: #2a672d;
  }
  .new-box-img-item {
    width: 91px;
    height: 55px;
    background: #f1f5f2;
    display: inline-block;
    text-align: center;
    margin: 0px 9px 0 0;
    vertical-align: middle;
  }
  .new-box-img-item-top {
    font-size: 22px;
    font-family: DINAlternate-Bold, DINAlternate;
    color: #5b675c;
    line-height: 24px;
    margin-top: 7px;
    margin-bottom: 2px;
  }
  .new-box-img-item-bottom {
    height: 14px;
    font-size: 12px;
    font-family: DINAlternate-Bold, DINAlternate;
    color: #5b675c;
    line-height: 14px;
  }
  .new-box-cont {
    flex: 1;
    max-height: 60px;
    overflow: hidden;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 21px;
    display: inline-block;
    vertical-align: middle;
  }
  .new-box-cont-title {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 21px;
    max-height: 42px;
    overflow: hidden;
  }
  .new-box-cont-title :deep(a) {
    color: #666666;
    text-decoration: none;
  }
  .new-box-cont-time {
    height: 21px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 21px;
  }
  .new-image-wrap {
    display: flex;
  }
  .new-image-wrap .new-image-item {
    margin: 10px;
  }
  .new-detail-item {
    padding: 10px;
  }
  .new-detail-item .new-detail-item-title {
    font-size: 16px;
    padding: 10px 0;
    border-bottom: 1px solid #eee;
  }
  .new-detail-item .new-detail-item-cont {
    font-size: 14px;
    padding: 0 0 10px;
  }
  .new-detail-item .new-detail-item-cont :deep(img) {
    display: block;
    max-width: 100%;
  }
  .new-detail-item-title-link {
    text-decoration: none;
    color: #000;
  }
  </style>